import { css } from "@emotion/css";
import { Colors, FontSizeInPx, FontWeight, LineHeightInPx, Spacing } from "@snapchat/snap-design-system";

import { fontFamilySecondary } from "../styles";

export const feedbackRatingV1Header = css`
    margin-bottom: ${Spacing["1XS"]}px;

    font-size: ${FontSizeInPx.LARGE}px;
    font-weight: ${FontWeight.BOLD};
    line-height: ${LineHeightInPx.LARGE}px;
    color: ${Colors.Black.V200};
`;

export const feedbackRatingV1Subheader = css`
    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.MEDIUM};
    line-height: 18px;
    color: ${Colors.Gray.V300};
`;

export const feedbackRatingV1HeaderContainer = css`
    margin-bottom: ${Spacing.SM}px;
`;

export const feedbackRatingV1TextArea = css`
    margin-top: ${Spacing.LG}px;
`;

export const feedbackRatingV1Container = css`
    textarea {
        ${fontFamilySecondary};
    }
`;
